import { render, staticRenderFns } from "./AnsweredAForm.vue?vue&type=template&id=08e33758&scoped=true&"
import script from "./AnsweredAForm.vue?vue&type=script&lang=js&"
export * from "./AnsweredAForm.vue?vue&type=script&lang=js&"
import style0 from "./AnsweredAForm.vue?vue&type=style&index=0&id=08e33758&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e33758",
  null
  
)

export default component.exports